<template>
    <div class="inquiry">
        <Header ref="header" :title="title" @backPage="onBackPage"></Header>
        <From ref="memu" @submit="handleSubmit" />
    </div>
</template>

<script>
import Header from '../../common/header'
import From from './component/from'
import { Toast } from 'vant'
import { getSubmitEnquiry } from '../api/api'
export default {
    name: 'enquiryAdd',
    components: {
        Header,
        From
    },
    data () {
        return {
            title: '提交询价单'
        }
    },
    methods: {
        onBackPage () {
            this.$router.go(-1)
        },
        async handleSubmit (data) {
            Toast.loading({
                message: '提交中...',
                duration: 0,
                forbidClick: true
            })
            try {
                await getSubmitEnquiry(data)
                Toast.clear()
                this.$router.push({ path: '/b2b/inquiry/inquiryFeedback' })
            } catch (error) {
                this.$refs.memu.handleBtn()
                Toast.clear()
            }
        }
    }
}
</script>